<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <div class="pull-left">
        <router-link to="/top-categories" class="btn btn-orange"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div>      -->
  <!--      <div class="pull-right ">
        <a @click.prevent="handleDelete()" title="Delete" class="btn btn-danger"><i class="ti-trash"></i> Delete</a>
      </div> -->
      <p  class="clearfix"></p>

      <top-category-form :route="route" @on-submit="onCategorySubmit"></top-category-form>
    </div>
  </div>
</template>
<script>

  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import TopCategoryForm from './TopCategoryForm.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      TopCategoryForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        categoryModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onCategorySubmit (model, isValid) {
        this.categoryModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/TopCategories/TopCategoryEdit.vue